import { formValidation, phoneDigitLengthMessage } from '@/utilities/formValidation'

/** Mirrors `formValidation.phone` messages (single source of truth). */
export const signUpMobileMessages = {
  pattern: formValidation.phone.pattern!.message,
  digitCount: phoneDigitLengthMessage,
} as const

const phonePattern = formValidation.phone.pattern!.value

export type SignUpMobileIssue = { message: string; met: boolean }

/**
 * When the value is empty after trim, mobile is optional — no checklist.
 * Same rules as `formValidation.phone` (pattern + digit length).
 */
export function getSignUpMobileRequirements(value: string): SignUpMobileIssue[] {
  const trimmed = value.trim()
  if (trimmed === '') return []

  const patternOk = phonePattern.test(trimmed)
  const digitsOnly = trimmed.replace(/[\s\-\(\)\+]/g, '')
  const digitsOk = digitsOnly.length >= 10 && digitsOnly.length <= 15

  return [
    { message: signUpMobileMessages.pattern, met: patternOk },
    { message: signUpMobileMessages.digitCount, met: digitsOk },
  ]
}

export function signUpMobileMeetsRequirements(value: string): boolean {
  const reqs = getSignUpMobileRequirements(value)
  return reqs.length === 0 || reqs.every((r) => r.met)
}

/** First validation error for server-side schema, or undefined if valid/empty. */
export function getSignUpMobileValidationError(raw: string | null | undefined): string | undefined {
  if (raw == null) return undefined
  const trimmed = String(raw).trim()
  if (trimmed === '') return undefined
  if (!phonePattern.test(trimmed)) return signUpMobileMessages.pattern
  const validated = formValidation.phone.validate(trimmed)
  return validated === true ? undefined : validated
}
